import { render, staticRenderFns } from "./PlusReceptBase.vue?vue&type=template&id=5c184b43&scoped=true"
import script from "./PlusReceptBase.vue?vue&type=script&lang=ts"
export * from "./PlusReceptBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c184b43",
  null
  
)

export default component.exports